import { RoleSortOption } from '@rematter/frontend-lib-api-client';

import { ExternalRoleRecord, ExternalRoleStatus } from '../types';

import { createQueryHook } from '~/shared/providers/api';

export interface ExternalRolesQueryParams {
  searchTerm?: string;
  sorting?: RoleSortOption[];
  limit?: number;
  offset?: number;
}

export interface ExternalRolesQueryResult {
  roles: ExternalRoleRecord[];
  total: number;
}

export const useExternalRolesQuery = createQueryHook(
  'settings.customerPortal.roles',
  (params: ExternalRolesQueryParams) => ({
    coreRoles: {
      __args: {
        filter: {
          type: 'EXTERNAL' as const,
          searchTerm: params.searchTerm || undefined,
          sorting: params.sorting,
          pagination: {
            limit: params.limit ?? 20,
            offset: params.offset ?? 0,
          },
        },
      },
      entries: {
        id: true,
        name: true,
        archived: true,
      },
      page: {
        total: true,
      },
    },
  }),
  {
    select: (data): ExternalRolesQueryResult => ({
      roles:
        data?.coreRoles.entries.map((role) => ({
          id: role.id,
          name: role.name,
          userCount: 0,
          status: (role.archived ? 'archived' : 'active') as ExternalRoleStatus,
        })) ?? [],
      total: data?.coreRoles.page.total ?? 0,
    }),
  },
);
